import { cx } from "./util";

export interface CountdownOverlayProps {
  /** Seconds remaining. `null` hides the overlay entirely. */
  value: number | null;
  /** What happens when it hits zero. Announced, and shown small. */
  caption?: string;
  className?: string;
}

/**
 * Purely visual — SPEC is explicit that there is no audio cue, because the
 * refresher pass has just been playing with sound and a beep would land in
 * the recording. The number is keyed so each tick restarts the punch.
 */
export function CountdownOverlay({ value, caption, className }: CountdownOverlayProps) {
  return (
    <>
      {/* Kept mounted so the announcement region is stable across ticks. */}
      <span className="bd-sr-only" aria-live="assertive" aria-atomic="true">
        {value === null ? "" : `${value}. ${caption ?? ""}`}
      </span>

      {value === null ? null : (
        <div className={cx("bd-overlay", className)} aria-hidden="true">
          <span key={value} className="bd-ring-el bd-ring" />
          <span key={`n${value}`} className="bd-countdown-num t-display t-outlined bd-punch">
            {value}
          </span>
          {caption ? <span className="bd-countdown-caption t-label">{caption}</span> : null}
        </div>
      )}
    </>
  );
}
